var map = {
	"./aquarius.svg": 5892,
	"./aries.svg": 2327,
	"./bg.svg": 4551,
	"./cancer.svg": 2091,
	"./capricorn.svg": 9411,
	"./gemini.svg": 5549,
	"./leo.svg": 6432,
	"./libra.svg": 3060,
	"./pisces.svg": 9152,
	"./sagittarius.svg": 9139,
	"./scorpio.svg": 4267,
	"./shooting_star.svg": 9488,
	"./taurus.svg": 6302,
	"./virgo.svg": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3617;